<template>
  <b-container fluid id="edit-primary-school">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="dots"
    ></loading>
    <div id="edit-primary-school">
      <h1 class="title">{{ schoolName }}</h1>
      <div id="alerts">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >You have successfully edited this school!</b-alert
        >
        <b-alert :show="showError" dismissible variant="danger">
          Something went wrong. Please check all required fields and try again.
        </b-alert>
      </div>
      <b-row class="mt-4">
        <b-col>
          <b-card
            v-on:click="toggleInfo()"
            v-bind:class="{ white: !bInfo, blue: bInfo }"
          >
            <span>
              <h1>
                <b-icon-caret-down v-if="bInfo"></b-icon-caret-down>
                <b-icon-caret-left v-else></b-icon-caret-left>
                Info
                <b-icon-caret-down v-if="bInfo"></b-icon-caret-down>
                <b-icon-caret-right v-else></b-icon-caret-right>
              </h1>
            </span>
            <div v-if="bInfo" v-on:click.stop id="info">
              <b-row>
                <b-col>
                  <h4 class="sub-title">Basic Information</h4>
                  <div class="name mt-4">
                    <label for="name">Name:</label>
                    <b-form-input
                      name="name"
                      type="text"
                      id="school-name"
                      v-model="schoolName"
                      required
                      :state="nameInput()"
                    ></b-form-input>
                  </div>
                  <div id="type" class="dropdown mt-4">
                    <label for="type">Registered With Government:</label>
                    <br />
                    <b-form-select v-model="regWithGov" name="type">
                      <option disabled value>Select...</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </b-form-select>
                  </div>
                </b-col>
                <b-col>
                  <geo-info
                    singular="school"
                    plural="primarySchools"
                    :coords="true"
                    parent="primary-school"
                  ></geo-info>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <confirm-submit v-if="isAdmin"></confirm-submit>
                  <b-button
                    v-if="isAdmin"
                    :size="'lg'"
                    :variant="'primary'"
                    class="app_school_btn mb-4"
                    @click.prevent="updateSchool"
                    :disabled="isDisabled"
                    >Save Changes</b-button
                  >
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-tabs card>
            <b-tab title="School's Students" active>
              <div class="students">
                <h4 class="sub-title">School's Students</h4>
                <primary-school-students></primary-school-students>
              </div>
            </b-tab>
            <b-tab title="Form Input" active>
              <div class="form-input">
                <h4 class="sub-title">Form Input</h4>
                <m-e-form-input></m-e-form-input>
              </div>
            </b-tab>
            <b-tab title="Export">
              <div class="form-input">
                <h4 class="sub-title">Export Primary School Leaners Data</h4>
                <m-e-export></m-e-export>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <br />
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import SchoolBasic from "@/components/SchoolBasic";
import PrimarySchoolStudents from "@/components/PrimarySchoolStudents";
import MEFormInput from "@/components/StudentsMEFormInput";
import GeoInfo from "@/components/GeoInfo";
import Breadcrumb from "@/components/Breadcrumb";
import MEExport from "@/components/MEExport";
import Loader from "vue-loading-overlay";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "EditPrimarySchool",
  mixins: [flash, scrollTo],
  components: {
    SchoolBasic,
    GeoInfo,
    PrimarySchoolStudents,
    MEFormInput,
    ConfirmSubmit,
    Loader,
    MEExport
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
      bInfo: false,
      isLoading: true,
      fullPage: true
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOL: "primarySchools/GET_SCHOOL",
      UPDATE_SCHOOL: "primarySchools/UPDATE_SCHOOL",
      RESET_SCHOOLS_STATE: "primarySchools/RESET_SCHOOLS_STATE"
    }),
    toggleInfo() {
      this.bInfo = !this.bInfo;
    },
    async updateSchool() {
      if (!this.$store.state.confirmed) {
        alert("Please confirm the information above is correct");
        return;
      }
      if (
        this.$store.state.primarySchools.school.name === "" ||
        this.$store.state.primarySchools.school.country === ""
      ) {
        this.scrollTo(0, 0);
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.UPDATE_SCHOOL();
        this.scrollTo(0, 0);
        this.flashSuccess();
        await this.$store.commit("resetConfirmed");
        await this.RESET_SCHOOLS_STATE();
        setTimeout(
          () => this.$router.push({ name: "PrimarySchoolsList" }),
          1500
        );
      }
    },
    nameInput() {
      return this.$store.state.primarySchools.school.school_name.length > 2;
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin"
    }),
    schoolName: {
      get() {
        return this.$store.state.primarySchools.school.school_name;
      },
      set(val) {
        this.$store.commit("primarySchools/school_name", val);
      }
    },
    regWithGov: {
      get() {
        return this.$store.state.primarySchools.school.registered_with_gov;
      },
      set(val) {
        this.$store.commit("primarySchools/registered_with_gov", val);
      }
    }
  },
  async created() {
    await this.GET_SCHOOL();
    this.isLoading = false;
  }
};
</script>

<style scoped>
#edit-primary-school {
  width: 90%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
.blue {
  background: #eaedf7;
}
.blue:hover {
  cursor: pointer;
}
.white {
  background: #ffffff;
}
.white:hover {
  background: #eaedf7;
  cursor: pointer;
}
form input,
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
